// Path-based (not a custom protocol) so it survives rehype-sanitize without an allowlist.
const ARTIFACT_LINK_PREFIX = "/artifacts/";

const ARTIFACT_ID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function buildArtifactLinkHref(artifactId: string): string {
  return `${ARTIFACT_LINK_PREFIX}${artifactId}`;
}

export function parseArtifactLinkHref(href: string): string | null {
  if (!href.startsWith(ARTIFACT_LINK_PREFIX)) return null;
  const id = href.slice(ARTIFACT_LINK_PREFIX.length);
  if (!ARTIFACT_ID_REGEX.test(id)) return null;
  return id;
}
